const GuestPaymentActionTypes = {
  SAVE_URL_ORDER: 'SAVE_URL_ORDER',
  SAVE_ROUTE_NAME: 'SAVE_ROUTE_NAME',
}

export default GuestPaymentActionTypes
